/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Description_PlaceholderInputs */

const en_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description or notes...`)
};

const fr_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description ou notes...`)
};

const de_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung oder Anmerkungen...`)
};

const it_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione o note...`)
};

const ru_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание или примечания...`)
};

const es_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción o notas...`)
};

const zh_cn2_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述或备注……`)
};

const ja_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明またはメモ...`)
};

const hi_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण या टिप्पणियाँ...`)
};

const pt_pt2_manual_qc_description_placeholder = /** @type {(inputs: Manual_Qc_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição ou notas...`)
};

/**
* | output |
* | --- |
* | "Description or notes..." |
*
* @param {Manual_Qc_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_description_placeholder = /** @type {((inputs?: Manual_Qc_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_description_placeholder(inputs)
	if (locale === "de") return de_manual_qc_description_placeholder(inputs)
	if (locale === "it") return it_manual_qc_description_placeholder(inputs)
	if (locale === "ru") return ru_manual_qc_description_placeholder(inputs)
	if (locale === "es") return es_manual_qc_description_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_description_placeholder(inputs)
	if (locale === "ja") return ja_manual_qc_description_placeholder(inputs)
	if (locale === "hi") return hi_manual_qc_description_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_description_placeholder(inputs)
	return en_manual_qc_description_placeholder(inputs)
});